import React from 'react'
import { useHistory } from 'react-router-dom'
import { Grid } from '@the-platform-group/component-library'
import { Button } from '@the-platform-group/component-library/Button'
import PeopleMergeFlow from './components/people/MergeFlow'
import PageHeader from 'components/Layout/PageHeader'

const PeopleMergeForm = () => {
  const history = useHistory()

  return (
    <>
      <PageHeader
        title="Preview and Merge People Profiles"
        subtitle="Please ensure all data is correct and up-to-date. If any FactSet data requires updating please raise an RPD."
        subNav={
          <Grid item>
            <Button variant="outlined" onClick={() => history.push('/merge-profiles/people')}>
              Back
            </Button>
          </Grid>
        }
      />
      <PeopleMergeFlow />
    </>
  )
}

export default PeopleMergeForm
